import { CopyElement, Input } from "@ui";
import style from "./CryptoModal.module.scss";
import cn from "classnames";
import { IoClose } from "react-icons/io5";

export function CryptoModal(
    { data, close }:
        {
            data: {
                amount: number;
                wallet: string;
            } | null,
            close: () => void
        }
) {
    return (
        <div
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    close()
                }
            }}
            className={cn(style.backing, data ? "flex" : "hidden")}
        >
            <div className={style.container}>
                <div className="overflow-auto h-full">
                    <div className="flex items-center justify-between pr-[15px]">
                        <p className={style.label}>USDT-TRC20</p>
                        <button>
                            <IoClose
                                onClick={close}
                            />
                        </button>
                    </div>
                    <img src={"https://quickchart.io/qr?text=" + data?.wallet + "&size=400&margin=2"} alt="" />
                    <div className="flex flex-col gap-[5px] items-start mb-[15px]">
                        <p className={style.valueLabel}>TRC20:</p>
                        <CopyElement
                            element={<p className={style.value}>{data?.wallet}</p>}
                            copyText={data?.wallet || ""}
                        />
                    </div>
                    <div className="flex gap-[5px] items-baseline mb-[5px]">
                        <p className={style.valueLabel}>Сума:</p>
                        <CopyElement
                            element={<p className={style.value}>{data?.amount}</p>}
                            copyText={String(data?.amount || "")}
                        />
                    </div>
                    <p className={style.warning}>Потрібно відправити на гаманець саме ту сумму яка вказана (без урахування комісії). В іншому випадку вони не будуть зараховані  автоматично .</p>
                    <div className="flex justify-center">
                        <button onClick={close} className={style.button}>
                            Поповнено
                        </button>
                    </div>
                    <p className={style.time}>Кошти з'являться на балансі протягом 3 хвилин</p>
                </div>
            </div>
        </div>
    )
}